import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../../baseUrl";
import Spinner from "../../../Components/Spinner/Spinner";

const StudentUpdate = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));
  const { id } = useParams();

  const [registrationNumber, setRegistrationNumber] = useState("");
  const [studentName, setStudentName] = useState("");
  const [studentAddress, setStudentAddress] = useState("");
  const [studentContact, setStudentContact] = useState("");
  const [password, setPassword] = useState("");
  const [studentParentName, setStudentParentName] = useState("");
  const [studentParentContact, setStudentParentContact] = useState("");
  const [studentParentRelation, setStudentParentRelation] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  //   get exam by id
  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/get-student-by-id/${id}`, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setRegistrationNumber(res.data.student.registrationNumber);
        setStudentName(res.data.student.studentName);
        setStudentAddress(res.data.student.studentAddress);
        setStudentContact(res.data.student.studentPhoneNumber);
        setPassword(res.data.student.password);
        setStudentParentName(res.data.student.parents.parentName);
        setStudentParentContact(res.data.student.parents.parentNumber);
        setStudentParentRelation(res.data.student.parents.relation);
      });
  }, [id, adminToken]);

  console.log(registrationNumber);
  // handle submit for create exam
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `${baseUrl}/admin/update-student/${id}`,
        {
          registrationNumber,
          studentName,
          studentAddress,
          studentContact,
          password,
          studentParentName,
          studentParentContact,
          studentParentRelation,
        },
        {
          headers: {
            Authorization: `Bearer ${adminToken}`,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.success === true) {
          toast.success(res.data.message);
          navigate("/admin/students");
        } else {
          toast.error(res.data.message);
          navigate("/admin/students");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      {loading && <Spinner />}
      <form onSubmit={handleSubmit}>
        <div>
          <div className="mb-1 mt-10 ml-10 md:flex">
            <div className="mb-4 md:mr-2 md:mb-0 ml-2">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Register Number
              </label>
              <input
                className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="text"
                name="registrationNumber"
                value={registrationNumber}
                onChange={(e) => setRegistrationNumber(e.target.value)}
                required
              />
            </div>

            <div className="mb-4 md:mr-2 md:mb-0 ml-2">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Student Name
              </label>
              <input
                className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="text"
                name="studentName"
                value={studentName}
                onChange={(e) => setStudentName(e.target.value)}
                required
              />
            </div>
            <div className="mb-1 md:mr-2 md:mb-0">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Student Address
              </label>
              <input
                className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="text"
                name="studentAddress"
                value={studentAddress}
                onChange={(e) => setStudentAddress(e.target.value)}
                required
              />
            </div>
            <div className="mb-1 md:mr-2 md:mb-0">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Student Contact
              </label>
              <input
                className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="number"
                name="studentContact"
                value={studentContact}
                onChange={(e) => setStudentContact(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-1 ml-10 md:flex">
            <div className="mb-4 md:mr-2 md:mb-0">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Student Password
              </label>
              <input
                className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="text"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="mb-1 md:mr-2 md:mb-0">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Parent's Name
              </label>
              <input
                className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="text"
                name="studentParentName"
                value={studentParentName}
                onChange={(e) => setStudentParentName(e.target.value)}
                required
              />
            </div>
            <div className="mb-1 md:mr-2 md:mb-0">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Parent's Contact
              </label>
              <input
                className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="number"
                name="studentParentContact"
                value={studentParentContact}
                onChange={(e) => setStudentParentContact(e.target.value)}
                required
              />
            </div>
            <div className="mb-4 md:mr-2 md:mb-0">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Student's Relation
              </label>
              <input
                className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                type="text"
                name="studentParentRelation"
                value={studentParentRelation}
                onChange={(e) => setStudentParentRelation(e.target.value)}
                required
              />
            </div>
          </div>
        </div>

        {/*body*/}
        {/*footer*/}
        <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
          <button
            className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </>
  );
};

export default StudentUpdate;
